// @flow
import * as React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import withQuery from "hoc/withQuery"
import withRouter from "hoc/withRouter"
import { openModal } from "data/modals/actions"
import urls from "data/router/urls"
import { affiliateCurrentDate } from "data/affiliate/graphql"
import { reservationStatuses } from "data/reservations/constants"
import { isLateForReturn } from "data/reservations/helpers"
import type { Reservation } from "data/reservations/types"
import ProductAvailability from "modals/ProductAvailability"
import Button from "components/Button"
import ToolTip from "components/ToolTip"
import { Flex } from "componentsStyled/Layout/Flex"
import { getToolTipMessage } from "./messages"
import { Center } from "./styled"

const ExtendReservation = ({ data, handleExtend, reservation }) => {
  // If reservations is finished
  if (
    (reservation.status !== reservationStatuses.confirmed &&
    reservation.status !== reservationStatuses.checked_out) ||
    isLateForReturn(reservation, data.affiliateCurrentDate)
  ) {
    return null
  }
  const productName = reservation.productItem.productVariant.product.productGroup.name

  return (
    <Center>
      <Flex>
        <Button onClick={handleExtend}>Extend reservation</Button>
        <ToolTip
          withButton
          content={getToolTipMessage(productName, "extension")}
        />
      </Flex>
    </Center>
  )
}

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  reservation: Reservation,
|}

const enhancer: HOC<*, Outter> = compose(
  withRouter,
  withQuery(affiliateCurrentDate, {
    noEmpty: true,
    variables: props => ({
      affiliateId: props.reservation.productItem.affiliate.id,
    }),
    noLoader: true,
  }),
  withConnect(() => ({}), mapDispatchToProps),
  withHandlers({
    handleExtend: props => () => {
      const originalReservation = {
        startDate: props.reservation.start,
        endDate: props.reservation.end,
        resId: props.reservation.id,
      }

      // Apollo cache polutes ProductVariantAvailableAffiliate list, filter them out
      const affiliateId = props.reservation.productItem.affiliate.id
      const variantAffiliate = props.reservation.productItem.productVariant.affiliates.find(a =>
        a.affiliateId === affiliateId
      )
      const productVariant = props.reservation.productItem.productVariant

      variantAffiliate && props.openModal(ProductAvailability, {
        productVariant: props.reservation.productItem.productVariant,
        variantAffiliate,
        originalReservation: originalReservation,
        callback: () => {
            props.history.push(
              urls.reserveProduct(
                productVariant.id,
                variantAffiliate.affiliateId,
              ),
            )
          }
      })
    },
  }),
)

export default enhancer(ExtendReservation)



// WEBPACK FOOTER //
// ./src/pages/Reservation/ExtendReservation/index.js